import type { ContribuinteIcms, TabelaPrecoResponse, UFS } from '@triade/contracts';

/**
 * Destino tributario (UF e contribuinte de ICMS) na tela. So apresentacao e leitura de flags: nenhum imposto, aliquota ou R$
 * e calculado aqui. Os valores vem da API; estes helpers apenas dizem se o seletor aparece e qual e o padrao do cadastro.
 */

/** UF de destino (sigla da lista oficial de contratos). */
export type UfDestino = (typeof UFS)[number];

/**
 * Modo da vigencia da tabela na data da operacao: true = ESTRUTURADO, false = LEGADO, null = sem vigencia na data
 * (ou resposta antiga sem `modo`). So a tabela estruturada aceita UF e contribuinte; na legada a API ignora.
 */
export function estruturadaNaData(tabela: TabelaPrecoResponse | undefined, data: string): boolean | null {
  const vigencia = tabela?.vigencias?.find((v) => v.validFrom <= data && (v.validTo === null || data < v.validTo));
  if (!vigencia || vigencia.modo === undefined) return null;
  return vigencia.modo === 'ESTRUTURADO';
}

/**
 * Contribuinte padrao do cadastro do cliente, como a API decide (sem cadastro ou CONTRIBUINTE = sim; ISENTO e NAO_CONTRIBUINTE = nao).
 * So serve para mostrar o padrao no seletor antes de salvar; quem decide o calculo e a API.
 */
export function contribuinteDoCadastro(c: ContribuinteIcms | null | undefined): boolean {
  return c === undefined || c === null || c === 'CONTRIBUINTE';
}

/** Rotulos do contribuinte no seletor (texto fixo da tela). */
export const ROTULO_CONTRIBUINTE = { sim: 'Sim (contribuinte)', nao: 'Não (não contribuinte)' } as const;
